import { axiosVersion } from "@/plugins/axios";
/**
 * @description 获取版本信息
 * @url https://cydkkiyrccjz.sealosgzg.site/api/docs#/%E8%BD%AF%E4%BB%B6%E7%89%88%E6%9C%AC/apps_software_apis_version_list_patient
 * @api /api/knowledge/entity_guest
 */
const GetVersionList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axiosVersion.get("api/software/version/", params).then(({ data }) => {
            if (loading) {
                loading.close();
            }
            resolve(data);
        }).catch((err: any) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};
export { GetVersionList }